import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import SectionHeader from '../../../../components/molecules/SectionHeader/SectionHeader';
import ContactPreference from '../../molecules/ContactPreference';
import ContactInput from '../../molecules/ContactInput';
import ContentSpacer from '../../../../components/atoms/ContentSpacer';

const ClientContact = (props) => {
  const {
    contact,
    setContact,
    disabled,
    hasDocumentAssigned,
  } = props;

  const [contactOptions, setContactOptions] = useState([
    {
      value: 'email',
      label: 'E-Mail',
      id: 'contactEmail',
      isChecked: false,
    },
    {
      value: 'phone',
      label: 'Phone',
      id: 'contactPhone',
      isChecked: true,
    },
  ]);

  useEffect(() => {
    const optionsCopy = contactOptions.slice();

    for (let i = 0; i < optionsCopy.length; i += 1) {
      if (optionsCopy[i].value === contact.contactPreference) {
        optionsCopy[i].isChecked = true;
      } else {
        optionsCopy[i].isChecked = false;
      }
    }

    setContactOptions(optionsCopy);
  }, [contact.contactPreference]);

  const handleChange = (e) => {
    setContact((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePhoneChange = (value) => {
    let newValue = value;
    if (!value) {
      newValue = '';
    }
    setContact((prev) => ({
      ...prev,
      phone: newValue,
    }));
  };

  return (
    <section>
      <SectionHeader value="Client Contact" />
      <ContentSpacer>
        <ContactPreference
          contactOptions={contactOptions}
          disabled={disabled}
          onChange={handleChange}
        />
        <ContactInput
          label="Cell Phone"
          type="phone"
          name="phone"
          value={contact.phone}
          onChange={handlePhoneChange}
          disabled={disabled || contact.contactPreference !== 'phone'}
        />
        <ContactInput
          label="E-mail Address"
          type="email"
          name="email"
          value={contact.email}
          onChange={handleChange}
          disabled={disabled || (contact.contactPreference !== 'email' && !hasDocumentAssigned)}
        />
      </ContentSpacer>
    </section>
  );
};

ClientContact.propTypes = {
  contact: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    contactPreference: PropTypes.string,
  }).isRequired,
  setContact: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hasDocumentAssigned: PropTypes.bool.isRequired,
};

ClientContact.defaultProps = {
  disabled: false,
};

export default ClientContact;
